export default "__VITE_ASSET__BOwo1rQb__"